<template>
  <v-card-text class="app-toolbar">
    <div class="app-toolbar__left">
      <slot name="left" />
    </div>

    <div class="app-toolbar__right">
      <slot name="right" />
    </div>
  </v-card-text>
</template>

<script>
export default {
  name: 'AppToolbar',
}
</script>

<style scoped>
.app-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 20px 16px 16px !important;
}

.app-toolbar__left {
  flex: 1;
  min-width: 0;
}

.app-toolbar__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  flex-shrink: 0;
}
</style>
